'use client';

import React from 'react';

export default function PatientLayout({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
